export default __webpack_public_path__ + "static/footer-bg-ea6e11c285c136cee98ca6e1df3da154.jpg";